export default {
  title: 'Submit changes',
  subTitleStart: 'You are about to lock ',
  subTitleEnd: '. Please confirm changes and name the reason for locking.',
  placeholder: 'Lock reason',
  buttonCancel: 'Cancel',
  buttonSubmit: 'Submit',
};
